module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "twitter-official.d7f1cf7d.svg" + "?" + Date.now();